import Highcharts from 'highcharts';
import ChartingHighchartsBaseController from './charting_highcharts_base_controller';

export default class extends ChartingHighchartsBaseController {
  renderChart() {
    const chartIndex = this.chartTarget.getAttribute('data-highcharts-chart');
    this.chart = Highcharts.charts[chartIndex];

    if (this.chart) {
      this.chart.destroy();
    }

    this.chart = Highcharts.chart(this.chartTarget, this.buildConfig());
  }

  // eslint-disable-next-line class-methods-use-this -- polymorphic override
  resolveClickValue(point, _member) {
    return point.name || point.id;
  }
}
